import * as React from 'react';
import { Calendar } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

type CalendarComponentProps = {
    mode?: 'single';
    defaultMonth?: Date;
    numberOfMonths?: number;
    selected?: Date;
    onSelect?: (date: Date | undefined) => void;
    className?: string;
    disabled?: (date: Date) => boolean;
    initialFocus?: boolean;
};

export function CalendarComponent({ mode = 'single', defaultMonth, numberOfMonths = 1, selected, onSelect, className, disabled }: CalendarComponentProps) {
    // Only single mode supported for now
    return (
        <div className={className}>
            <Calendar
                value={selected}
                onChange={(value: any /* Date | Date[] | null */, _event?: any) => {
                    if (onSelect && value instanceof Date) {
                        onSelect(value);
                    }
                }}
                tileDisabled={disabled ? ({ date }: { date: Date }) => disabled(date) : undefined}
                defaultActiveStartDate={defaultMonth}
                selectRange={false}
                showDoubleView={numberOfMonths === 2}
            />
        </div>
    );
}
